"use strict";
exports.__esModule = true;
exports.blockProperty = void 0;
var blockProperty = window.MTBlockEditor.decorator.blockProperty;
exports.blockProperty = blockProperty;
